export const pendingChatActionTypes = {
    GET_USERS_IN_ROOM : 'GET_USERS_IN_ROOM',
    GET_ROOM_USER_MAIN_REQUEST : 'GET_ROOM_USER_MAIN_REQUEST',
    GET_ROOM_USER_MAIN_FAILURE : 'GET_ROOM_USER_MAIN_FAILURE',
    GET_USERS_IN_ROOM_SUCCESS : 'GET_USERS_IN_ROOM_SUCCESS'

}